"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const WaitSvg = () => (
  <svg width="1em" height="0.96em" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="1.25" y="0.75" width="22.5" height="22.5" rx="11.25" stroke="currentColor" strokeWidth="1.5"/>
<circle cx="12.5" cy="12" r="4" fill="currentColor"/>
</svg>

)

const WaitIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={WaitSvg} {...props} />
);

export default WaitIcon